module.exports = __webpack_public_path__ + "img/Carte-Virtuelle-Ecobank-Apaym.ee059d9b.png";